<div class="flex flex-col gap-2">
  <div class="flex items-center justify-between">
    <h3 class="!m-0 !font-bold">Terminals</h3>
    <div class="flex gap-2">
      @if ((hasTestTerminal$ | async) === false) {
        <pt-loader-button
          type="stroked"
          color="accent"
          [loading]="isCreatingTestTerminal()"
          (clicked)="createTestTerminal()"
        >
          Create Test Terminal
        </pt-loader-button>
      }
      <button mat-flat-button color="primary" (click)="pairNewTerminal()">
        Pair New Terminal
      </button>
    </div>
  </div>

  <table class="w-full" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell>Name</th>
      <td *matCellDef="let terminal" mat-cell>{{ terminal.name }}</td>
    </ng-container>

    <ng-container matColumnDef="serialNumber">
      <th *matHeaderCellDef mat-header-cell>Serial Number</th>
      <td *matCellDef="let terminal" mat-cell class="mat-caption">
        {{ terminal.serialNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastActive">
      <th *matHeaderCellDef mat-header-cell class="w-44">Last Paired</th>
      <td *matCellDef="let terminal" mat-cell class="mat-caption w-44">
        @if (terminal.lastPaired; as lastPaired) {
          {{ lastPaired | moment | amDateFormat: dateFormat }}
        } @else {
          <span class="text-red-500">Never Paired</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef mat-header-cell class="w-20"></th>
      <td *matCellDef="let terminal" mat-cell class="w-20 !text-right">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="editTerminalPair(terminal)">
              <mat-icon color="accent">edit</mat-icon> Edit
            </button>
            @if (terminal.serialNumber !== testTerminalSerial) {
              <button mat-menu-item (click)="deleteTerminalPair(terminal)">
                <mat-icon color="warn">delete</mat-icon> Delete
              </button>
            }
          </ng-template>
        </mat-menu>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>
</div>
